interface StatItem {
  label: string;
  value: string;
  suffix: string;
  icon: string;
}

export default function StatsSection({ stats }: { stats: StatItem[] }) {
  return (
    <section className="w-full py-14 md:py-20 bg-foreground-950">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-white font-heading">
            平台数据
          </h2>
          <p className="text-foreground-400 text-sm mt-2">
            专业数据服务，为电竞爱好者提供最可靠的竞技信息
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="text-center p-6 rounded-lg bg-foreground-900/50 border border-foreground-800/50"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-500/20">
                <i className={`${stat.icon} text-xl text-primary-400`}></i>
              </div>
              <p className="text-3xl md:text-4xl font-bold text-white font-heading mb-1">
                {stat.value}
              </p>
              {stat.suffix && (
                <p className="text-xs text-accent-400 mb-1">{stat.suffix}</p>
              )}
              <p className="text-sm text-foreground-400">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}